module.exports = __webpack_public_path__ + "img/doctor_share_bg1.05c35bfc.png";